module.exports = __webpack_public_path__ + "static/media/H.0b72e9e0.png";